/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}.select-card[_ngcontent-%COMP%]:hover{border:1px solid #457efa}"];
export { styles as styles };
